import { TransformedAddress } from "../../templates/ecommerce/cart/types/cartApiTypes";

/**
 * Compares two address objects to determine if they are effectively the same.
 * Ignores fields that typically don't affect shipping/billing equality logic (like email/phone/tckn).
 *
 * @param addr1 The first address (e.g., Billing)
 * @param addr2 The second address (e.g., Shipping)
 * @returns true if the core address fields match.
 */
export const areAddressesEqual = (
  addr1: TransformedAddress | undefined,
  addr2: TransformedAddress | undefined
): boolean => {
  if (!addr1 || !addr2) return false;

  // Fields to compare for equality
  const keys: (keyof TransformedAddress)[] = [
    "firstName",
    "lastName",
    "company",
    "country",
    "state",
    "city",
    "address1",
    "address2",
    "postcode",
  ];

  return keys.every((key) => {
    // Normalize values to empty strings for safe comparison (handles null vs undefined vs "")
    const val1 = addr1[key] || "";
    const val2 = addr2[key] || "";
    return val1 === val2;
  });
};
